import { render, staticRenderFns } from "./QuestionTitle.vue?vue&type=template&id=1c4bb2ec&scoped=true"
import script from "./QuestionTitle.vue?vue&type=script&lang=js"
export * from "./QuestionTitle.vue?vue&type=script&lang=js"
import style0 from "./QuestionTitle.vue?vue&type=style&index=0&id=1c4bb2ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4bb2ec",
  null
  
)

export default component.exports